import { render, staticRenderFns } from "./ArticuloTipo.vue?vue&type=template&id=0ea25112&scoped=true&"
import script from "./ArticuloTipo.vue?vue&type=script&lang=js&"
export * from "./ArticuloTipo.vue?vue&type=script&lang=js&"
import style0 from "./ArticuloTipo.vue?vue&type=style&index=0&id=0ea25112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea25112",
  null
  
)

export default component.exports